import { render, staticRenderFns } from "./WidgetConstructor.vue?vue&type=template&id=54106dca&scoped=true&"
import script from "./WidgetConstructor.vue?vue&type=script&lang=js&"
export * from "./WidgetConstructor.vue?vue&type=script&lang=js&"
import style0 from "./WidgetConstructor.vue?vue&type=style&index=0&id=54106dca&lang=scss&scoped=true&"
import style1 from "./WidgetConstructor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54106dca",
  null
  
)

export default component.exports